import { createSlice, createAsyncThunk, current } from "@reduxjs/toolkit";
import axios from "../config/axiosWithLocation";

const initialState = {
  dishes: null,
  error: null,
  isLoading: false,
};

export const fetchCategoryDishes = createAsyncThunk(
  "dish/fetchCategoryDishes",
  async (payload, thunkAPI) => {
    const response = await axios
      .get("/categories/items/" + payload.categoryId)
      .then((res) => {
        return { id: payload.categoryId, data: res.data.items };
      })
      .catch((err) => {
        return thunkAPI.rejectWithValue(
          "Something went wrong! Please try again later"
        );
      });
    return response;
  }
);

export const fetchAllDishes = createAsyncThunk(
  "home/fetchAllDishes",
  async (payload, thunkAPI) => {
    let dishes = {};
    // for (let categoryId of payload.categories) {
    //   await axios
    //     .get("/categories/items/" + categoryId)
    //     .then((res) => {
    //       dishes[categoryId] = res.data.items;
    //     })
    //     .catch((err) => {
    //       return thunkAPI.rejectWithValue(
    //         "Something went wrong! Please try again later"
    //       );
    //     });
    // }
    // let requests = [];
    // for (let categoryId of payload.categories) {
    //   requests.push(axios.get("/categories/items/" + categoryId));
    // }

    // let data = await Promise.all(requests).then((res) => {
    //   let optData = res.map((obj) => obj.data);
    //   console.log(optData);

    //   return res;
    // });
    return dishes;
  }
);

export const dishSlice = createSlice({
  name: "dish",
  initialState,
  reducers: {
    setDishes: (state, action) => {
      state.dishes = [...action.payload];
    },
    clearDishes: (state, action) => {
      state.dishes = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchCategoryDishes.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchCategoryDishes.fulfilled, (state, action) => {
      state.isLoading = false;
      if (!current(state).dishes) {
        state.dishes = {
          [action.payload.id]: action.payload.data,
        };
      } else {
        state.dishes[action.payload.id] = action.payload.data;
      }
    });
    builder.addCase(fetchCategoryDishes.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
    builder.addCase(fetchAllDishes.pending, (state, action) => {
      state.isLoading = true;
    });
    builder.addCase(fetchAllDishes.fulfilled, (state, action) => {
      state.isLoading = false;
      state.dishes = action.payload;
    });
    builder.addCase(fetchAllDishes.rejected, (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    });
  },
});

// Action creators are generated for each case reducer function
export const { setDishes, clearDishes } = dishSlice.actions;

export default dishSlice.reducer;
